import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { updateAllFilters } from '@src/store/slices/searchFiltersSlice';
import Checkbox from '../';

const CheckboxWithRedux = (props) => {
  const dispatch = useDispatch();
  // currently defaults to the searchFilters slice - we can extend this to
  // target different slices if necessary
  const selections = useSelector((state) => state.searchFilters[props.group]);

  const onChange = (value) => {
    dispatch(updateAllFilters({ group: props.group, value }));
  };

  return <Checkbox {...props} onChange={onChange} selections={selections} />;
};

CheckboxWithRedux.propTypes = {
  /**
   * Selects the group (key) of the redux state that needs to be updated when
   * the state of this component changes
   */
  group: PropTypes.string
};

CheckboxWithRedux.defaultProps = {
  autoUnselectOnAll: false,
  hasIcons: false,
  selectAllIcon: null,
  selectAllLabel: 'Any'
};

export default CheckboxWithRedux;
